import { useState } from 'react';
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    FormHelperText,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Button,
} from '@mui/material';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { DuplicateAccount } from '../DuplicateAccountList/types/types';
import { AccountKeyword, Account } from '../../../../stores/AccountStore';
import EditAccountDrawer from '../../../../features/accounts/EditAccountDrawer';
import { SelectOption } from '../../../../types/common';

interface AccountSelectProps {
    accounts: SelectOption[];
    control: Control<any>;
    errors: FieldErrors;
    onAddAccount: (newAccountName: string, accountId: string) => void;
}

const AccountSelect: React.FC<AccountSelectProps> = ({ accounts, control, errors, onAddAccount }) => {
    const [selectedAccount, setSelectedAccount] = useState(undefined as undefined | Account);
    const [editOpen, setEditOpen] = useState(false); // State to handle new account input

    const handleAddAccount = async (newAccount: Account) => {
        if (!accounts.some((s) => s.value === newAccount.id)) {
            onAddAccount(newAccount.name, newAccount.id); // Pass new account back to parent component to update state
        }

        setEditOpen(false);
    };

    const handleAccountExists = (account: DuplicateAccount) => {
        console.log(account);
    };

    const onNewAccount = () => {
        setSelectedAccount({
            id: crypto.randomUUID(),
            name: '',
            industryId: '',
            hqAddress: '',
            hqProvince: '',
            revenueId: '',
            employeeSizeId: '',
            accountStatusId: '',
            hqCountryId: '',
            hqPostalCode: '',
            hqRegionId: '',
            keywords: [] as AccountKeyword[],
        } as Account);

        setEditOpen(true);
    };

    return (
        <>
            <FormControl fullWidth sx={{ mb: 1 }}>
                <InputLabel htmlFor="account.id">Account</InputLabel>
                <Controller
                    name="account.id"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Select
                            fullWidth
                            size="small"
                            value={value}
                            label="Select Account"
                            onBlur={onBlur}
                            onChange={onChange}
                            inputProps={{ placeholder: 'Select Account', 'data-testid': 'account' }}
                        >
                            {accounts.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.name}
                                </MenuItem>
                            ))}
                            {/* Option to add new account */}
                            <MenuItem onClick={onNewAccount} value="">
                                + Add Account
                            </MenuItem>
                        </Select>
                    )}
                />
                {errors.account?.id && (
                    <FormHelperText sx={{ color: 'error.main' }}>Please select a value!</FormHelperText>
                )}
            </FormControl>

            {selectedAccount && (
                <EditAccountDrawer
                    open={editOpen}
                    onClose={() => setEditOpen(false)}
                    onSaved={handleAddAccount}
                    account={selectedAccount}
                    key={selectedAccount.id}
                />
            )}
        </>
    );
};

export default AccountSelect;
